/**
 * React Query client configuration
 * Optimized for mutation-heavy API with minimal caching needs
 */
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes - prevent unnecessary refetches
      gcTime: 1000 * 60 * 10, // 10 minutes garbage collection
      retry: (failureCount, error) => {
        // Don't retry client errors (4xx), only retry server errors (5xx)
        if (error instanceof ApiError && error.status && error.status < 500) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      // Disable automatic background refetching since we have no GET endpoints
      refetchOnMount: false,
      refetchInterval: false,
    },
    mutations: {
      retry: (failureCount, error) => {
        // Don't retry client errors (4xx), only retry server errors (5xx)
        if (error instanceof ApiError && error.status && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      // Global mutation error handling with conditional logic
      onError: (error: unknown) => {
        // Global error logging/analytics
        console.error('Mutation failed:', error);

        // Could add global error reporting here
        // reportErrorToService(error);
      },
    },
  },
});
